import { array, object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class ItemButton extends PageBlock {
  public getType(): string {
    return "ItemButton";
  }

  protected init(): any {
    return {
      props: {
        title: "액션버튼",
        items: [],
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          items: array()
            .of(
              object().shape({
                icon: string().url().required().label("아이콘"),
                title: string().max(64).required().label("제목"),
                description: string().max(128).nullable().label("설명"),
                badge: string().max(4).nullable().label("배지 텍스트"),
                badge_type: string()
                  .oneOf(["red", "orange", "yellow", "green", "blue", "indigo", "purple"])
                  .nullable()
                  .label("배지 색상")
                  .when("badge", {
                    is: (badge: string) => badge && badge.length > 0,
                    then: (schema) => schema.required("배지 색상을 선택해주세요"),
                    otherwise: (schema) => schema.nullable().transform(() => null),
                  }),
                tag: string().max(4).nullable().label("태그 텍스트"),
                tag_type: string()
                  .oneOf(["red", "orange", "yellow", "green", "blue", "indigo", "purple"])
                  .nullable()
                  .label("태그 색상")
                  .when("tag", {
                    is: (tag: string) => tag && tag.length > 0,
                    then: (schema) => schema.required("태그 색상을 선택해주세요"),
                    otherwise: (schema) => schema.nullable().transform(() => null),
                  }),
                href: string().required().label("링크"),
                type: string().oneOf(["link", "block", "tel"]).required().label("타입"),
                target: string()
                  .oneOf(["_self", "_blank"])
                  .when("type", {
                    is: "link",
                    then: (schema) => schema.required("링크 타입을 선택해주세요"),
                  }),
              }),
            )
            .min(1)
            .required()
            .label("버튼 목록"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
